import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';


function PriorityDropdown({ onChangeDropdown, modelName, required, selectedValue,isDisable, showLabel }) {
    const [selectedPriorityOption, setSelectedPriorityOption] = useState([]);
    const [getPriorityOptions, setPriorityOptions] = useState([]);

    let labelHtml;
    if(showLabel === undefined){
        labelHtml = 
            <label className="form-label">
                Priority { required === true ? <span style={{ color: "red" }}>*</span> : "" }
            </label>
    } else {    
        if(showLabel === true){
            labelHtml = 
                <label className="form-label">
                    Priority { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
        } 
    }

    function handleChange(e, actionMeta) {
        setSelectedPriorityOption(e);
        onChangeDropdown(e, actionMeta);
    };
    function setDataOnLoad(data){
        let priorityOption = [];
        priorityOption = data.map(p => ({ value: p.PriorityId, label: p.PriorityName, name: 'Priority', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setPriorityOptions(priorityOption);
        setSelectedPriorityOption(priorityOption.filter(x => x.value === selectedValue));
    }
    useEffect(() => {
        const fetchPriorities = async () => {
            try {
              let dropdownDetails = {
                UserId: localStorage.getItem('userId'),
                IsForDropodown: 1
              };
              const response = await axios.get(getApiBaseUrl() + "/getAllPriorities", {
                params: dropdownDetails
              });
              if (response.status === 200) {
                setDataOnLoad(response.data.data[0]);
              }
            } catch (error) {
              console.log(error);
            }
        };
        fetchPriorities();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                {labelHtml}
                <Select
                    className="PriorityDropdown"
                    name={modelName}
                    value={selectedPriorityOption ? selectedPriorityOption : []}
                    isClearable={true}
                    isDisabled = {isDisable}
                    options={getPriorityOptions || []}
                    onChange={handleChange}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })  // ensure it's above table
                    }}
                />
            </div>
        </div>
    )
}

export default PriorityDropdown